import { Injectable } from '@angular/core'
import BaseService from '@ui/Services/BaseService'
import PaymentMethod from '@account/PaymentMethod'
import { createPaymentMethod, mapCardBrandToLabel } from '@account/utils'

@Injectable()
export class PaymentMethodService extends BaseService<PaymentMethod> {
	public filterable: PaymentMethod

	protected endpoint = '/api/account/payment-methods'

	constructor() {
		super()

		this.filterable = createPaymentMethod()
	}

	public update = async (
		paymentMethod: PaymentMethod,
	): Promise<PaymentMethod> => {
		const response = await this.put(`${this.endpoint}/${paymentMethod.id}`, {
			payment_method: {
				default: paymentMethod.defaultMethod,
			},
		})

		return this.mapToObject(response)
	}

	public deleteMethod = async (paymentMethod: PaymentMethod): Promise<void> => {
		await this.delete(`${this.endpoint}/${paymentMethod.id}`)
	}

	public mapToObject = (json): PaymentMethod => {
		return new PaymentMethod(
			json.id,
			json.remote_id,
			mapCardBrandToLabel(json.brand),
			json.last4,
			json.expiry,
			json.default,
		)
	}
}
